<template>
  <div>
    <b-row>
      <b-colxx xxs="12">
        <piaf-breadcrumb :heading="$t('menu.booking-cancel')"/>
        <div class="separator mb-5"></div>
      </b-colxx>
    </b-row>
    <b-row>
      <b-colxx xxs="12">
        <b-card class="mb-4" title="취소 신청 리스트">
          <booking-list
            :items="items"
            :fields = "fields"
            :current-page="currentPage"
            :per-page="perPage"
            @click-row="onClickRow"
            @confirm-proc="confirmCancel"
            @deny-proc="denyCancel"
          />

          <b-pagination v-if="lastPage > 1"
                        size="sm"
                        align="center"
                        :total-rows="total"
                        :per-page="perPage"
                        v-model="currentPage"
          >
            <template v-slot:next-text>
              <i class="simple-icon-arrow-right"/>
            </template>
            <template v-slot:prev-text>
              <i class="simple-icon-arrow-left"/>
            </template>
            <template v-slot:first-text>
              <i class="simple-icon-control-start"/>
            </template>
            <template v-slot:last-text>
              <i class="simple-icon-control-end"/>
            </template>
          </b-pagination>


          <div class="top-right-button-container mb-2">
            <b-button @click="allConfirm" variant="primary" size="sm" class="top-right-button">선택된 취소신청 일괄승인
            </b-button>
          </div>

          <b-row align-v="center" align-h="center" class="mt-0" no-gutters>
            <b-modal modal-class="notooltip" id="bookingdetails" ref="bookingdetails" size="lg" title="예약 상태" :hide-backdrop="false"
                     :no-close-on-backdrop="true">
              <booking-details-viewer :data="bookingInfo"/>
              <template slot="modal-footer">
                <b-button variant="outline-primary" @click="hideModal">닫기</b-button>
                <b-button variant="warning" @click="denyProcess">취소불가</b-button>
                <b-button variant="primary" @click="confirmProcess" class="mr-1">취소신청 승인</b-button>
              </template>
            </b-modal>
          </b-row>

        </b-card>
      </b-colxx>
    </b-row>
  </div>

</template>

<script>
  import {
      mapGetters,
      mapActions ,
      mapMutations
    } from "vuex";
  import 'vue-select/dist/vue-select.css'
  import BookingDetailsViewer from "./components/BookingDetailView";
  import BookingList from "./components/BookingList";
  import api from '../../constants/api'
  import {alignTableCenter} from "../../utils";

  export default {
    components: {
      'booking-details-viewer': BookingDetailsViewer,
      'booking-list' : BookingList
    },
    data() {
      return {
        isLoad : false ,
        currentPage : 1,
        perPage : 30 ,
        lastPage : 0 ,
        total : 0 ,
        bookingId : null,
        fields: [
          {key: 'bookingNo', label: "예약번호" , ...alignTableCenter},
          {key: 'storeName', label: "매장명" , ...alignTableCenter},
          {key: 'visitorName', label: "예약자" , ...alignTableCenter},
          {key: 'visitorPhone', label: "전화번호" , ...alignTableCenter},
          {key: 'headcount', label: "인원" , ...alignTableCenter},
          {key: 'bookingRequestDate', label: "예약신청일" , ...alignTableCenter},
          {key: 'reservationDate', label: "방문예정일" , ...alignTableCenter},
          {key: 'bookingStatus', label: "예약상태" , ...alignTableCenter},
          {key: 'channelName', label: "예약경로" , ...alignTableCenter},
          {key: 'button', label: "처리" , ...alignTableCenter},
          {key: 'selected', label: "" , ...alignTableCenter},
        ],
        items: [],
        bookingInfo: null
      }
    },
    computed : {
      ...mapGetters(['currentUser' , 'siteName'])
    },
    watch: {
      currentPage() {
        this.searchData()
      }
    },
    mounted() {
        this.searchData()
    },
    methods: {
      searchData(){
        this.isLoad = false
        const reqURL = api.changeAPI(this.siteName, api.basicURL + api.auth.login)
        const params = {}

        this.$http.get(reqURL, {
          params: params,
          headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
        }).then(res => {
          if (res.data.code === "OK") {


          } else {
            throw 400
          }
        }).catch(err => {

        })

        this.items = [{
          id: 1,
          bookingId: "20200898761",
          store: "구로점",
          goods: "발렌타이데이 평일 점심 특가",
          user: "홍길동",
          phone: "010-0000-0000",
          headcount: 4,
          bookingDate: "20200101",
          visitingDate: "20200214",
          bookingStatus: "예약대기",
          channel: "자사 사이트",
          selected: false
        }]

      },
      allConfirm() {
        let flag = false
        let cnt = 0
        this.items.forEach(function (value, index) {
          if (value.selected) {
            flag = true
            cnt++
          }
        })

        if (flag === false) {
          alert('취소신청 일괄승인 처리 할 예약을 선택해주세요.')
          return false
        }

        if( confirm( cnt + '건에 대한 취소신청 일괄승인 처리를 하시겠습니까? ') ) {
          const reqURL = api.changeAPI(this.siteName, api.basicURL + api.auth.login)
          const params = {}

          this.$http.post(reqURL, params ,{
            headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
          }).then(res => {
            if (res.data.code === "OK") {

            } else {
              throw 400
            }
          }).catch(err => {

          })
        }
      },
      onClickRow(item, index, target) { //상세보기
        const reqURL = api.changeAPI(this.siteName, api.basicURL + api.auth.login)
        const params = {

        }

        this.$http.get(reqURL, {
          params: params,
          headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
        }).then(res => {
            if ( res.data.code === "OK" ) {

            } else {
                throw 400
            }
        }).catch(err => {

        })

        this.bookingInfo = {
          bookingId: "202023423423",
          user: "카피츄",
          phone: "010-0000-0000",
          headcount: {
            adult: 3,
            child: 1
          },
          goodsName: "발렌타인데이 주말 점심특가",
          request: '아기의자',
          store: "강남점",
          bookingDate: "2020-01-13 13:45:00",
          visitingDate: "2020-12-04 17:30:00",
          bookingStatus: "예약완료",
          channel: "위메프"
          ,
          purchaseList: [
            {coupon: "20202342934", goods: "성인 1인권", unused: false},
            {coupon: "20202323442", goods: "성인 1인권", unused: false},
            {coupon: "20202323423", goods: "어린이 1인권", unused: false}
          ],
        }

        this.showModal();
      },
      showModal() {
        this.$refs['bookingdetails'].show();
      },
      hideModal() {
        this.$refs['bookingdetails'].hide();
      },
      setVisited() {

      },
      denyCancel(id) {
        this.bookingId = id
        this.denyProcess();
      },
      confirmCancel(id) {
        this.bookingId = id
        this.confirmProcess();
      },
      confirmProcess(){
        if (confirm('승인처리 하시겠습니까?')) {
          const reqURL = api.changeAPI(this.siteName, api.basicURL + api.auth.login)
          const params = {}

          this.$http.post(reqURL, params,{
            headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
          }).then(res => {
            if (res.data.code === "OK") {

            } else {
              throw 400
            }
          }).catch(err => {

          })
        }
      },
      denyProcess(){
        if (confirm('취소 불가 처리 하시겠습니까?')) {
          const reqURL = api.changeAPI(this.siteName, api.basicURL + api.auth.login)
          const params = {}

          this.$http.post(reqURL, params,{
            headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
          }).then(res => {
            if (res.data.code === "OK") {

            } else {
              throw 400
            }
          }).catch(err => {

          })
        }

      },
    }
  }
</script>

<style scoped>
  #coloredtext {
    color: blue;
  }
</style>
